import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Input, Checkbox } from 'components/forms'
import Link from 'components/link'

export default class OrderFields extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      hideStoreInput: this.props.hideStoreInput,
      originalStoreName: this.props.storeName.value,
    }

    this.handleWrongStore = this.handleWrongStore.bind(this)
  }

  static propTypes = {
    orderNumber: PropTypes.object.isRequired,
    storeName: PropTypes.object.isRequired,
    orderNumberNotAvailable: PropTypes.object.isRequired,
  }

  static defaultProps = {
    hideStoreInput: false,
  }

  handleWrongStore() {
    this.setState({
      hideStoreInput: false,
      originalStoreName: '',
    })
  }

  render() {
    const {
      storeName,
      orderNumber,
      orderNumberNotAvailable,
      registry,
      autofillStore,
    } = this.props

    return (
      <React.Fragment>
        {autofillStore && this.state.hideStoreInput ? (
          <Input type="hidden" {...storeName} />
        ) : (
          <Input
            label="Store Name"
            placeholder="(e.g. Amazon)"
            type="text"
            {...storeName}
          />
        )}
        <Input
          {...orderNumber}
          label={`Order Number`}
          labelAddon={
            this.state.hideStoreInput ? (
              <Link
                className="tiny text-center text-uppercase"
                onClick={this.handleWrongStore}
              >
                Change Store
              </Link>
            ) : null
          }
          type="text"
          groupClassName={'mbs'}
          help="Not sure where to find it? Check your email from the store."
          error={orderNumber.touched ? orderNumber.error : null}
        />
        <Checkbox
          {...orderNumberNotAvailable}
          label="I don't have an order number"
          error={
            orderNumberNotAvailable.touched
              ? orderNumberNotAvailable.error
              : null
          }
        />
      </React.Fragment>
    )
  }
}
